import React from 'react';
import MainApp from '@/modules/MainApp';
import { useUser } from '@dofleini/security';
import { authentication } from '@/settings/authentication';
import OnBoardingModule from '@/modules/onboarding';

import 'moment/locale/es-us';
import GlobalLayout from '@/layout/GlobalLayout';

function App () {
  const { user } = useUser();
  
  if (user && authentication?.activeOnboarding && !user?.onboardingCompleted)
    return <OnBoardingModule/>;
  
  if (user)
    return <MainApp/>;
  
  return <GlobalLayout>
    <MainApp/>
  </GlobalLayout>;
}

export default App;
